var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function makeError() {
    return new DOMException('The request is not allowed', 'NotAllowedError');
}
function copyClipboardApi(text) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!navigator.clipboard)
            throw makeError();
        return navigator.clipboard.writeText(text);
    });
}
function copyExecCommand(text) {
    return __awaiter(this, void 0, void 0, function* () {
        const o = document.createElement('span');
        (o.textContent = text),
            (o.style.whiteSpace = 'pre'),
            (o.style.webkitUserSelect = 'auto'),
            (o.style.userSelect = 'all'),
            document.body.appendChild(o);
        const t = window.getSelection(), r = window.document.createRange();
        t.removeAllRanges(), r.selectNode(o), t.addRange(r);
        let n = !1;
        try {
            n = window.document.execCommand('copy');
        }
        finally {
            t.removeAllRanges(), window.document.body.removeChild(o);
        }
        if (!n)
            throw makeError();
    });
}
function clipboardCopy(text) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield copyClipboardApi(text);
        }
        catch (o) {
            try {
                yield copyExecCommand(text);
            }
            catch (e) {
                throw e || o || makeError();
            }
        }
    });
}
export default clipboardCopy;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xpcGJvYXJkLWNvcHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2NsaXBib2FyZC1jb3B5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLFNBQVMsU0FBUztJQUNoQixPQUFPLElBQUksWUFBWSxDQUFDLDRCQUE0QixFQUFFLGlCQUFpQixDQUFDLENBQUM7QUFDM0UsQ0FBQztBQUVELFNBQWUsZ0JBQWdCLENBQUMsSUFBWTs7UUFDMUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxTQUFTO1lBQUUsTUFBTSxTQUFTLEVBQUUsQ0FBQztRQUM1QyxPQUFPLFNBQVMsQ0FBQyxTQUFTLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzdDLENBQUM7Q0FBQTtBQUVELFNBQWUsZUFBZSxDQUFDLElBQVk7O1FBQ3pDLE1BQU0sQ0FBQyxHQUFHLFFBQVEsQ0FBQyxhQUFhLENBQUMsTUFBTSxDQUFDLENBQUM7UUFDekMsQ0FBQyxDQUFDLENBQUMsV0FBVyxHQUFHLElBQUksQ0FBQztZQUNwQixDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsVUFBVSxHQUFHLEtBQUssQ0FBQztZQUM1QixDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsZ0JBQWdCLEdBQUcsTUFBTSxDQUFDO1lBQ25DLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxVQUFVLEdBQUcsS0FBSyxDQUFDO1lBQzVCLFFBQVEsQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBQy9CLE1BQU0sQ0FBQyxHQUFHLE1BQU0sQ0FBQyxZQUFZLEVBQVMsRUFDcEMsQ0FBQyxHQUFHLE1BQU0sQ0FBQyxRQUFRLENBQUMsV0FBVyxFQUFFLENBQUM7UUFDcEMsQ0FBQyxDQUFDLGVBQWUsRUFBRSxFQUFFLENBQUMsQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUNwRCxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQztRQUNYLElBQUk7WUFDRixDQUFDLEdBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQyxXQUFXLENBQUMsTUFBTSxDQUFDLENBQUM7U0FDekM7Z0JBQVM7WUFDUixDQUFDLENBQUMsZUFBZSxFQUFFLEVBQUUsTUFBTSxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDO1NBQzFEO1FBQ0QsSUFBSSxDQUFDLENBQUM7WUFBRSxNQUFNLFNBQVMsRUFBRSxDQUFDO0lBQzVCLENBQUM7Q0FBQTtBQUVELFNBQWUsYUFBYSxDQUFDLElBQVk7O1FBQ3ZDLElBQUk7WUFDRixNQUFNLGdCQUFnQixDQUFDLElBQUksQ0FBQyxDQUFDO1NBQzlCO1FBQUMsT0FBTyxDQUFDLEVBQUU7WUFDVixJQUFJO2dCQUNGLE1BQU0sZUFBZSxDQUFDLElBQUksQ0FBQyxDQUFDO2FBQzdCO1lBQUMsT0FBTyxDQUFDLEVBQUU7Z0JBQ1YsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLFNBQVMsRUFBRSxDQUFDO2FBQzdCO1NBQ0Y7SUFDSCxDQUFDO0NBQUE7QUFFRCxlQUFlLGFBQWEsQ0FBQyJ9